import React from 'react'
import StudentSidebar from '../StudentSidebar/StudentSidebar'
import { Link } from 'react-router-dom'

const StudentDashboard = () => {
    return (
        <div>
            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            {/* <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link> */}
                            &nbsp;&nbsp; Dashboard
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <StudentSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="row mt-3">
                                    <div className="col-lg-4 col-md-6 mb-4">
                                        <Link to="/student/browse-tutor"></Link>
                                        <div className="tutor-card-sec tutor-card-one">
                                            <Link to="/student/browse-tutor">
                                                <div className="img-sec">
                                                    <img
                                                        src="/assets/img/user/student-img-one.png"
                                                        className="img-fluid"
                                                    />
                                                </div>
                                            </Link>
                                            <Link to="/student/browse-tutor" className="tutor-text text-center">
                                                Browse Tutor
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 mb-4">
                                        <Link to="/student/request-for-tutor"></Link>
                                        <div className="tutor-card-sec tutor-card-two">
                                            <Link to="/student/request-for-tutor">
                                                <div className="img-sec">
                                                    <img
                                                        src="/assets/img/user/student-img-two.png"
                                                        className="img-fluid"
                                                    />
                                                </div>
                                            </Link>
                                            <Link to="/student/request-for-tutor" className="tutor-text text-center">
                                                Status Tutor Request
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 mb-4">
                                        <Link to="/student/my-sessions"></Link>
                                        <div className="tutor-card-sec tutor-card-three">
                                            <Link to="/student/my-sessions">
                                                <div className="img-sec">
                                                    <img
                                                        src="/assets/img/user/student-img-three.png"
                                                        className="img-fluid"
                                                    />
                                                </div>
                                            </Link>
                                            <Link to="/student/my-sessions" className="tutor-text text-center">
                                                My Session
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 mb-4">
                                        <Link to="/student/my-online-lecture"></Link>
                                        <div className="tutor-card-sec tutor-card-four">
                                            <Link to="/student/my-online-lecture">
                                                <div className="img-sec">
                                                    <img
                                                        src="/assets/img/user/student-img-four.png"
                                                        className="img-fluid"
                                                    />
                                                </div>
                                            </Link>
                                            <Link to="my-online-lecture" className="tutor-text text-center">
                                                My Online Lecture
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 mb-4">
                                        <Link to="/student/notes-and-handouts"></Link>
                                        <div className="tutor-card-sec tutor-card-five">
                                            <Link to="/student/notes-and-handouts">
                                                <div className="img-sec">
                                                    <img
                                                        src="/assets/img/user/student-img-five.png"
                                                        className="img-fluid"
                                                    />
                                                </div>
                                            </Link>
                                            <Link to="notes-and-handouts" className="tutor-text text-center ">
                                                Notes &amp; Handouts
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 mb-4">
                                        <Link to="/student/my-assignments"></Link>
                                        <div className="tutor-card-sec tutor-card-six">
                                            <Link to="/student/my-assignments">
                                                <div className="img-sec">
                                                    <img
                                                        src="/assets/img/user/assignments.png"
                                                        className="img-fluid tutor-img-six"
                                                    />
                                                </div>
                                            </Link>
                                            <Link to="my-assignments" className="tutor-text text-center">
                                                My Assignments
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </main>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default StudentDashboard